<template>
    <section>
        <div class="t-headline5 mt3">
            {{$t('1692')}}
            <!-- 회원가입 완료! -->
        </div>

        <div>
        <!-- <div> -->
            <div class="t-body3 mt6 t-color-bodyGrayA">
                {{$t('1693')}}<br>
                {{$t('1694',{str: brandName})}}
                <!-- 학생 계정 회원가입이 완료되었습니다.<br>
                {{brandName}}에서 바로 학습을 시작해보세요. -->
            </div>

            <div class="mt50">
                <button class="mdc-button mdc-button--raised btn-red w-full btn-big" @click="moveDegree()" @keypress="moveDegree()" tabindex="0">
                    {{$t('1695')}}
                    <!-- 학습 시작하기 -->
                </button>
            </div>
        </div>

        
        
    </section>
    
</template>

<script>
/**
 * 아이디 찾기 Step1 컴포넌트
 *
 * @author minkyoung.park@emcast.com
 * @author 
 * @since 2019.04
 */

// MDC Components 선언 S
import {MDCRipple} from '@material/ripple'


// API 임포트
import joinApi from '@/api/joinApi.js'

// Store 임포트
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'

// import format from 'string-format'
// format.extend(String.prototype, {})

export default {
    data() {
        return {
            brandName: 'EMCAST CLP',
            studentContents: '',
            parentContents: '',
            instructorContents: '',
        }
    },

    mixins: [joinMixin],

    computed : {
        ...mapState('join',{
            join : state => state,
        }),
    },

    mounted() {
        this.setMaterialUi()
        this.brandName = BRAND_NAME
        
    },

    methods: {
        // Store 변이 정의
        ...mapMutations('join', ['INIT_JOIN_STORE']),

        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        moveDegree() {
            this.$router.push('/login')
        }

        

    },

    

}
</script>

<style scoped>

</style>
